﻿import * as eventTypes from '../../../map/utils/eventTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
import Draw from 'ol/interaction/Draw.js';
import Modify from 'ol/interaction/Modify.js';
import WKT from 'ol/format/WKT';
import { getResolutionForScale } from '../../../map/utils/utils';
import makePanelDraggable from '../../utils/panelDrag';
import html2canvas from 'html2canvas';

export default class SpatialSearchControl {
    constructor(action, resourcesHandler, layerSettingsHandler, modalWrapper, rootURL, classId, mapControl, menuContainer, quickSearches, parentId) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.modalWrapper = modalWrapper;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.menuContainer = menuContainer;
        this.quickSearches = quickSearches;
        this.parentId = parentId;
        this.elementId = `map-action-${classId}-${action.Id}`;
        this.controlId = `spatial-search-${classId}-${action.Id}`;
        this.resultTreeId = `spatial-search-result-tree-${classId}-${action.Id}`;
        this.resultTreeReport = `spatial-analysis-result-report-${classId}-${action.Id}`;
        this.resultTreeClear = `spatial-analysis-result-clear-${classId}-${action.Id}`;
        this.point = `draw-point-${classId}-${action.Id}`;
        this.line = `draw-line-${classId}-${action.Id}`;
        this.polygon = `draw-polygon-${classId}-${action.Id}`;
        this.clear = `clear-draw-${classId}-${action.Id}`;
        this.search = `search-draw-${classId}-${action.Id}`;
        this.searchFormModalWrapper = `search-form-modal-wrapper-${classId}-${action.Id}`;
        this.dragHandle = `spatial-search-header-${classId}-${action.Id}`;
        this.panelDrag = null;
        this.active = false;
        this.actionConfig = null;
        this.drawingSource = null;
        this.resultSource = null;
        this.drawingInteraction = null;
        this.modifyInteraction = null;
        this.resolution = 150;
    }

    init() {
        this.actionConfig = JSON.parse(this.action.Content);

        if (this.parentId != null) {
            $('#' + this.parentId)[0].append(this._getGroupedActionButtonTemplate());
        } else {
            this.menuContainer.append(this._getActionButtonTemplate());
        }

        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        this.modalWrapper.innerHTML = this._getSpatialSearchTemplate();
        this._addSearchLayer();
        this._addSearchResultLayer();

        if (this.actionConfig.resultType == 'report') {
            $('#entity-search-results-' + this.controlId).hide();
        }

        $event.register(eventTypes.GENERAL_ACTION_SHOW, this._getGeneralActionShowHandler(), this, this.classId);

        this._initComponents();
    }

    _getGeneralActionShowHandler() {
        var handler = (eventName, data, sender) => {
            this._hidePanel();
        };

        return handler;
    }

    _initComponents() {
        if (this.quickSearches.length > 0) {
            $('#spatial-analysis-search-wrapper-' + this.controlId).show();

            $('#spatial-analysis-search-input-' + this.controlId).kendoComboBox({
                placeholder: this.resourcesHandler.get("SpatialAnalysisSearch"),
                dataTextField: "Name",
                dataValueField: "Name",
                filter: "contains",
                autoBind: false,
                suggest: true,
                height: Math.min(450, 0.75 * $('#' + this.mapControl.mapElementId).height()).toString(),
                dataSource: {
                    serverFiltering: true,
                    filter: [],
                    transport: {
                        read: {
                            url: this.rootURL + "Map/MapSearch",
                            data: () => {

                                if ($('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").dataItem() == null
                                    || $('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").dataItem().Name != $('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").input.val()) {
                                    this.mapControl.showSearchResult(null, null, null);
                                }


                                var qs = [];
                                for (var i = 0; i < this.quickSearches.length; i++) {
                                    qs.push(this.quickSearches[i].Id);
                                }

                                return {
                                    searchText: removeDiacritics($('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").input.val()),
                                    idMap: this.mapControl.mapId,
                                    idMapSearch: JSON.stringify(qs)
                                }

                            }
                        },
                        prefix: ""
                    },
                },
                template: '<div class="d-flex"><div><span class="#: IconClass# pl-1 pt-1 pr-3" style="font-size:2rem;"> </span></div><div class="d-flex-column"><div class="color-primary" style="font-weight:400" >#: Name # </div><div>#: DataSourceName #</div></div></div>',
                noDataTemplate: (e) => {
                    return this.resourcesHandler.get("No data found");
                },
                change: (e) => {

                    if (e.sender.dataItem() != null) {

                        var wkt = e.sender.dataItem().Wkt;
                        var _dsConfig = null;
                        for (var i = 0; i < this.quickSearches.length; i++) {
                            if (this.quickSearches[i].Id == e.sender.dataItem().IdMapSearch) {
                                _dsConfig = this.quickSearches[i];
                                break;
                            }
                        }
                        this.drawingSource.clear();
                        this._removeInteraction();
                        this._clearSpatialAnalysis();

                        if (this.resultSource != null) {
                            this.resultSource.clear();
                        }

                        $('#' + this.search).removeClass('ml-auto');
                        $('#' + this.clear).addClass('ml-auto');
                        $('#' + this.clear).show();

                        var format = new WKT();
                        var feature = format.readFeature(wkt);
                        this.drawingSource.addFeatures([feature]);

                        var geom = feature.getGeometry();
                        var scale = wkt.indexOf('POINT') >= 0 ? 1000 : null;

                        if (scale == null || isNaN(scale) || scale < 0) {
                            this.mapControl.map.getView().fit(geom.getExtent(), { duration: 1000, padding: [50, 50, 50, 50] });
                        }
                        else {
                            var resolution = getResolutionForScale(scale, this.mapControl.map.getView().getProjection().getCode());
                            var extent = geom.getExtent();
                            var _x = extent[0] + (extent[2] - extent[0]) / 2;
                            var _y = extent[1] + (extent[3] - extent[1]) / 2;
                            var center = [_x, _y];
                            this.mapControl.map.getView().animate({
                                center: center,
                                resolution: resolution,
                                duration: 2000
                            });
                        }
                    }
                    else {
                        this.drawingSource.clear();
                        this._removeInteraction();
                        this._clearSpatialAnalysis();

                        if (this.resultSource != null) {
                            this.resultSource.clear();
                        }

                        $('#' + this.search).addClass('ml-auto');

                        $('#' + this.clear).hide();
                    }
                },
                close: (e) => {

                    if (e.sender.dataItem() == null || e.sender.dataItem().Name != e.sender.value()) {
                        this.drawingSource.clear();
                        this._removeInteraction();
                        this._clearSpatialAnalysis();

                        if (this.resultSource != null) {
                            this.resultSource.clear();
                        }

                        $('#' + this.search).addClass('ml-auto');

                        $('#' + this.clear).hide();
                    }
                    else {
                        var wkt = e.sender.dataItem().Wkt
                        var _dsConfig = null;
                        for (var i = 0; i < this.quickSearches.length; i++) {
                            if (this.quickSearches[i].Id == e.sender.dataItem().IdMapSearch) {
                                _dsConfig = this.quickSearches[i];
                                break;
                            }
                        }
                        this.drawingSource.clear();
                        this._removeInteraction();
                        this._clearSpatialAnalysis();

                        if (this.resultSource != null) {
                            this.resultSource.clear();
                        }

                        $('#' + this.search).removeClass('ml-auto');
                        $('#' + this.clear).addClass('ml-auto');
                        $('#' + this.clear).show();

                        var format = new WKT();
                        var feature = format.readFeature(wkt);
                        this.drawingSource.addFeatures([feature]);

                        var geom = feature.getGeometry();
                        var scale = wkt.indexOf('POINT') >= 0 ? 1000 : null;

                        if (scale == null || isNaN(scale) || scale < 0) {
                            this.mapControl.map.getView().fit(geom.getExtent(), { duration: 2000, padding: [50, 50, 50, 50] });
                        }
                        else {
                            var resolution = getResolutionForScale(scale, this.mapControl.map.getView().getProjection().getCode());
                            var extent = geom.getExtent();
                            var _x = extent[0] + (extent[2] - extent[0]) / 2;
                            var _y = extent[1] + (extent[3] - extent[1]) / 2;
                            var center = [_x, _y];
                            this.mapControl.map.getView().animate({
                                center: center,
                                resolution: resolution,
                                duration: 2000
                            });
                        }
                    }
                }
            });
            $('#spatial-analysis-search-wrapper-' + this.controlId + ' .k-select').addClass("bg-primary");
            $('#spatial-analysis-search-wrapper-' + this.controlId + ' .k-select').addClass("text-white");
            $('#spatial-analysis-search-wrapper-' + this.controlId + ' .k-select .k-icon').removeClass("k-i-arrow-60-down");
            $('#spatial-analysis-search-wrapper-' + this.controlId + ' .k-select .k-icon').addClass("k-i-search");

            $('#spatial-analysis-search-input-' + this.controlId + '-list .k-list-scroller').slimScroll(
                {
                    position: 'right',
                    railVisible: true,
                    alwaysVisible: false
                });

            $('#spatial-analysis-search-input-' + this.controlId + "-list.k-list-container").css({ "max-height": 0.5 * $('#' + this.mapControl.mapElementId).height() + "px" });

            new ResizeSensor(jQuery('#' + this.mapControl.mapElementId), () => {
                $('#spatial-analysis-search-input-' + this.controlId + "-list.k-list-container").css({ "max-height": 0.5 * $('#' + this.mapControl.mapElementId).height() + "px" });
            });
        }

        $('#spatial-analysis-close-' + this.controlId).on('click', (evt) => {
            this._hidePanel();
        });

        // panoul se poate muta de antet, ca sa nu acopere zona de harta cautata
        this.panelDrag = makePanelDraggable(this.modalWrapper, document.getElementById(this.dragHandle), {
            bounds: () => document.getElementById(this.mapControl.mapElementId),
            content: () => document.getElementById(this.controlId)
        });

        $('#' + this.point).on('click', (evt) => {
            $('#' + this.point).addClass('btn-primary');
            $('#' + this.point).removeClass('btn-secondary');
            $('#' + this.line).removeClass('btn-primary');
            $('#' + this.line).addClass('btn-secondary');
            $('#' + this.polygon).removeClass('btn-primary');
            $('#' + this.polygon).addClass('btn-secondary');
            $('#' + this.search).removeClass('ml-auto');
            $('#' + this.clear).addClass('ml-auto');
            $('#' + this.clear).show();

            if ($('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox") != null) {
                $('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").value(null);
            }

            this.drawingSource.clear();
            this._addDrawingInteraction('Point');
            this._clearSpatialAnalysis();

            if (this.resultSource != null) {
                this.resultSource.clear();
            }
        });

        $('#' + this.line).on('click', (evt) => {
            $('#' + this.line).addClass('btn-primary');
            $('#' + this.line).removeClass('btn-secondary');
            $('#' + this.point).removeClass('btn-primary');
            $('#' + this.point).addClass('btn-secondary');
            $('#' + this.polygon).removeClass('btn-primary');
            $('#' + this.polygon).addClass('btn-secondary');
            $('#' + this.search).removeClass('ml-auto');
            $('#' + this.clear).addClass('ml-auto');
            $('#' + this.clear).show();

            if ($('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox") != null) {
                $('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").value(null);
            }

            this.drawingSource.clear();
            this._addDrawingInteraction('LineString');
            this._clearSpatialAnalysis();

            if (this.resultSource != null) {
                this.resultSource.clear();
            }
        });

        $('#' + this.polygon).on('click', (evt) => {
            $('#' + this.polygon).addClass('btn-primary');
            $('#' + this.polygon).removeClass('btn-secondary');
            $('#' + this.point).removeClass('btn-primary');
            $('#' + this.point).addClass('btn-secondary');
            $('#' + this.line).removeClass('btn-primary');
            $('#' + this.line).addClass('btn-secondary');
            $('#' + this.search).removeClass('ml-auto');
            $('#' + this.clear).addClass('ml-auto');
            $('#' + this.clear).show();

            if ($('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox") != null) {
                $('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").value(null);
            }

            this.drawingSource.clear();
            this._addDrawingInteraction('Polygon');
            this._clearSpatialAnalysis();

            if (this.resultSource != null) {
                this.resultSource.clear();
            }
        });

        $('#' + this.clear).on('click', (evt) => {
            $('#' + this.point).removeClass('btn-primary');
            $('#' + this.point).addClass('btn-secondary');
            $('#' + this.line).removeClass('btn-primary');
            $('#' + this.line).addClass('btn-secondary');
            $('#' + this.polygon).removeClass('btn-primary');
            $('#' + this.polygon).addClass('btn-secondary');
            $('#' + this.clear).removeClass('ml-auto');
            $('#' + this.search).addClass('ml-auto');
            $('#' + this.clear).hide();

            if ($('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox") != null) {
                $('#spatial-analysis-search-input-' + this.controlId).data("kendoComboBox").value(null);
            }

            this.drawingSource.clear();
            this._removeInteraction();
            this._clearSpatialAnalysis();

            if (this.resultSource != null) {
                this.resultSource.clear();
            }
        });

        let dataSource = new kendo.data.HierarchicalDataSource({
            data: [], schema: {
                model: {
                    children: "Results"
                }
            }
        });

        $('#' + this.resultTreeId).kendoTreeView({
            template: (e) => {
                if (e.item.hasChildren) {
                    return `<div class="search-tree-parent"><span style="white-space: break-spaces;">` + (e.item.TemplateName != null ? e.item.TemplateName : e.item.MapLayerName) + `</span</div>`;
                } else {
                    let idLayer = e.item.parent().parent().IdMapLayer;
                    let id = e.item.PkVal;
                    return `<div class="search-tree-child">` + e.item.Content + `</div><div><button class="btn btn-secondary fal fa-compress-arrows-alt ml-1 ` + 'spatial-search-item-center-' + this.controlId + `" style="padding: 0.15rem !important;" idLayer="` + idLayer + `" idObject="` + id + `"></button></div>`;
                }
            },
            dragAndDrop: false,
            loadOnDemand: false,
            dataSource: dataSource
        });

        $('#' + this.search).on('click', () => {
            this._executeSpatialAnalysisList();
        });

        $('#' + this.resultTreeClear).on('click', () => {
            this._clearSpatialAnalysis();
        });

        $('#' + this.resultTreeReport).on('click', () => {
            this._executeSpatialAnalysisReport();
        });
    }

    _executeSpatialAnalysisReport() {
        let format = new WKT();
        let features = this.drawingSource.getFeatures();
        let wktList = [];
        features.forEach(feature => {
            wktList.push(format.writeFeature(feature));
        });
        let projection = this.mapControl.map.getView().getProjection().getCode();

        let url = this.rootURL + 'Map/SpatialSearchResult';
        showLoadingPanel();
        $.ajax({
            url: url,
            type: 'POST',
            data: JSON.stringify({
                IdAction: this.action.Id,
                Wkt: wktList[0],
                Srid: projection,
                ResultType: 'report'
            }),
            async: true,
            dataType: 'json',
            contentType: "application/json",
            success: (result) => {
                if (wktList[0].indexOf('POINT') >= 0) {
                    var resolution = getResolutionForScale(500, this.mapControl.map.getView().getProjection().getCode());
                    var extent = this.drawingSource.getFeatures()[0].getGeometry().getExtent();
                    var _x = extent[0] + (extent[2] - extent[0]) / 2;
                    var _y = extent[1] + (extent[3] - extent[1]) / 2;
                    var center = [_x, _y];
                    this.mapControl.map.getView().animate({
                        center: center,
                        resolution: resolution,
                        duration: 2000
                    });
                } else {
                    this.mapControl.map.getView().fit(this.drawingSource.getFeatures()[0].getGeometry().getExtent(), { duration: 2000, padding: [100, 100, 100, 100] });
                }

                if (this.resultSource != null) {
                    let features = [];

                    result.forEach(resultItem => {
                        let parsed = this.mapControl.parseWktFeatures(resultItem.Results, 'Wkt', 'PkVal', projection, layerTypes.SPATIAL_SEARCH_RESULT);
                        parsed.forEach(x => features.push(x));
                    });

                    this.resultSource.clear();
                    this.resultSource.addFeatures(features);
                }

                setTimeout(() => {
                    this._generateReport(result);
                }, 2000);
            },
            error: () => {
                hideLoadingPanel();
            }
        });
    }

    _scaleImage(source, scaleFactor) {
        var c = document.createElement('canvas');
        var ctx = c.getContext('2d');
        var w = source.width * scaleFactor;
        var h = source.height * scaleFactor;
        c.width = w;
        c.height = h;
        ctx.drawImage(source, 0, 0, w, h);
        return (c);
    }

    _generateReport(result) {
        const mapCanvas = document.createElement('canvas');
        const scaleF = this.resolution / 96;
        mapCanvas.width = this.mapControl.map.getSize()[0] * scaleF;
        mapCanvas.height = this.mapControl.map.getSize()[1] * scaleF;
        const mapContext = mapCanvas.getContext('2d');
        mapContext.fillStyle = "white";
        mapContext.fillRect(0, 0, mapCanvas.width, mapCanvas.height);
        Array.prototype.forEach.call(
            document.querySelectorAll(".map canvas"),
            (canvas) => {
                if (canvas.width > 0) {
                    const opacity = canvas.parentNode.style.opacity;
                    mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                    const transform = canvas.style.transform;
                    if (transform != null && transform != '') {
                        const matrix = transform
                            .match(/^matrix\(([^\(]*)\)$/)[1]
                            .split(',')
                            .map(Number);
                        CanvasRenderingContext2D.prototype.setTransform.apply(
                            mapContext,
                            matrix
                        );
                    }
                    let cvs = this._scaleImage(canvas, scaleF);
                    mapContext.drawImage(cvs, 0, 0);
                }
            }
        );

        html2canvas(document.querySelector(".ol-overlaycontainer"), { backgroundColor: null }).then((canvas) => {
            if (canvas.width > 0) {
                mapContext.globalAlpha = 1;
                let cvs = this._scaleImage(canvas, scaleF);
                mapContext.drawImage(cvs, 0, 0);
                mapContext.setTransform(1, 0, 0, 1, 0, 0);
                let dataURL = mapCanvas.toDataURL('image/png');
                this._constructTemplate(result, dataURL);
            }
        }).catch((e) => {
            console.log('eroare generare imagine', e);
            hideLoadingPanel();
        });
    }

    _constructTemplate(result, img) {
        let template = '';
        if (this.actionConfig.header != null && this.actionConfig.header.trim() != '') {
            template += this.actionConfig.header.replaceAll('{map}', img);
        }

        result.forEach(item => {
            if (item.Content != null && item.Content.trim() != '') {
                template += item.Content;
            }
        });

        if (this.actionConfig.footer != null && this.actionConfig.footer.trim() != '') {
            template += this.actionConfig.footer.replaceAll('{map}', img);
        }

        let reportWindow = window.open();
        reportWindow.document.title = "Raport";
        reportWindow.document.write('<title>' + this.action.Text + '</title>' + template);

        hideLoadingPanel();
    }

    _addDrawingInteraction(type) {
        this._removeInteraction();
        this.mapControl.selectionHandler.isActive = false;
        this.drawingInteraction = new Draw({
            source: this.drawingSource,
            type: type,
        });

        this.drawingInteraction.on('drawend', (evt) => {
            evt.feature.set('xstate', 0);
            this.mapControl.map.removeInteraction(this.drawingInteraction);
            setTimeout(() => {
                this.mapControl.selectionHandler.isActive = true;
            }, 1000);
        });
        this.mapControl.map.addInteraction(this.modifyInteraction);
        this.mapControl.map.addInteraction(this.drawingInteraction);
    }

    _removeInteraction() {
        this.mapControl.selectionHandler.isActive = true;
        if (this.drawingInteraction != null) {
            this.drawingSource.clear();
            this.mapControl.map.removeInteraction(this.drawingInteraction);
            this.drawingInteraction = null;
            this.mapControl.map.removeInteraction(this.modifyInteraction);
        }
    }

    _clearSpatialAnalysis() {
        let dataSource = new kendo.data.HierarchicalDataSource({
            data: [], schema: {
                model: {
                    children: "Results"
                }
            }
        });

        $('#' + this.resultTreeId).data('kendoTreeView').setDataSource(dataSource);

        $('#' + this.resultTreeId).data('kendoTreeView').expand(".k-item");
    }

    _actionButtonClickHandler() {
        return () => this.active ? this._hidePanel() : this._showPanel();
    }

    _hidePanel() {
        this.active = false;
        $(this.modalWrapper).hide();
        $('#' + this.elementId).removeClass('selected');
    }

    _showPanel() {
        $event.notify(eventTypes.GENERAL_ACTION_SHOW, {}, this, this.classId);

        if (this.parentId != null) {
            $('#' + this.parentId).css('display', 'none');
        }

        this.active = true;
        $(this.modalWrapper).show();
        $('#' + this.elementId).addClass('selected');

        if (this.panelDrag != null) {
            this.panelDrag.clamp();
        }
    }

    _addSearchLayer() {
        this.mapControl.addTemporaryVectorLayer({
            name: layerTypes.SPATIAL_SEARCH,
            geometryType: geomTypes.GEOM_ALL,
            srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
            geomField: 'geom',
            idField: 'id',
            style: this.actionConfig.selectorStyle + '',
            visible: true,
            displayName: this.resourcesHandler.get('SpatialSearch'),
            ignoreStyle: false,
            addToLegend: false,
            parentId: null,
            showLegend: false,
            declutter: false,
            selectable: false
        }).then((res) => {
            this.drawingSource = this.mapControl.layerHandler.getLayerById(layerTypes.SPATIAL_SEARCH)[0].getSource();
            this.modifyInteraction = new Modify({
                source: this.drawingSource
            });
        });
    }

    _addSearchResultLayer() {
        if (this.actionConfig.resultStyle != null && ((typeof this.actionConfig.resultStyle == 'string' && this.actionConfig.resultStyle != '') || this.actionConfig.resultStyle != 0)) {
            this.mapControl.addTemporaryVectorLayer({
                name: layerTypes.SPATIAL_SEARCH_RESULT,
                geometryType: geomTypes.GEOM_ALL,
                srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
                geomField: 'geom',
                idField: 'id',
                style: this.actionConfig.resultStyle + '',
                visible: true,
                displayName: this.resourcesHandler.get('SpatialSearchResult'),
                ignoreStyle: false,
                addToLegend: false,
                parentId: null,
                showLegend: false,
                declutter: false,
                selectable: false
            }).then((res) => {
                this.resultSource = this.mapControl.layerHandler.getLayerById(layerTypes.SPATIAL_SEARCH_RESULT)[0].getSource();
            });
        }
    }

    _executeSpatialAnalysisList() {
        if (this.actionConfig.resultType == 'report') {
            this._executeSpatialAnalysisReport();
        } else {
            let format = new WKT();
            let features = this.drawingSource.getFeatures();
            let wktList = [];
            features.forEach(feature => {
                wktList.push(format.writeFeature(feature));
            });
            let projection = this.mapControl.map.getView().getProjection().getCode();

            let url = this.rootURL + 'Map/SpatialSearchResult';
            showLoadingPanel();

            $.ajax({
                url: url,
                type: 'POST',
                data: JSON.stringify({
                    IdAction: this.action.Id,
                    Wkt: wktList[0],
                    Srid: projection,
                    ResultType: 'list'
                }),
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: (result) => {
                    if (wktList[0].indexOf('POINT') >= 0) {
                        var resolution = getResolutionForScale(500, this.mapControl.map.getView().getProjection().getCode());
                        var extent = this.drawingSource.getFeatures()[0].getGeometry().getExtent();
                        var _x = extent[0] + (extent[2] - extent[0]) / 2;
                        var _y = extent[1] + (extent[3] - extent[1]) / 2;
                        var center = [_x, _y];
                        this.mapControl.map.getView().animate({
                            center: center,
                            resolution: resolution,
                            duration: 2000
                        });
                    } else {
                        this.mapControl.map.getView().fit(this.drawingSource.getFeatures()[0].getGeometry().getExtent(), { duration: 2000, padding: [100, 100, 100, 100] });
                    }

                    hideLoadingPanel();

                    let features = [];
                    let newTree = [];

                    result.forEach(resultItem => {
                        if (this.resultSource != null) {
                            let parsed = this.mapControl.parseWktFeatures(resultItem.Results, 'Wkt', 'PkVal', projection, layerTypes.SPATIAL_SEARCH_RESULT);
                            parsed.forEach(x => features.push(x));
                        }

                        if (resultItem.Results != null && resultItem.Results.length > 0) {
                            newTree.push(resultItem);
                        }
                    });

                    if (this.resultSource != null) {
                        this.resultSource.clear();
                        this.resultSource.addFeatures(features);
                    }

                    let dataSource = new kendo.data.HierarchicalDataSource({
                        data: newTree, schema: {
                            model: {
                                children: "Results"
                            }
                        }
                    });

                    $('#' + this.resultTreeId).data('kendoTreeView').setDataSource(dataSource);

                    $('#' + this.resultTreeId).data('kendoTreeView').expand(".k-item");

                    $('.spatial-search-item-center-' + this.controlId).on('click', (evt) => {
                        this._centerSpatialItem(evt);
                    });
                },
                error: () => {
                    hideLoadingPanel();
                }
            });
        }
    }

    _centerSpatialItem(evt) {
        let idLayer = evt.currentTarget.getAttribute('idLayer');
        let id = evt.currentTarget.getAttribute('idObject');
        this.mapControl.showFeature(idLayer, id, null, null, null);
    }

    _isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    _getSpatialSearchTemplate() {
        let marginLeft = '2rem';
        return `<div id="` + this.controlId + `" style="z-index: 10000; width: ` + (this._isMobile() ? `98vw` : `24.15rem`) + `; height: calc(100% - 7rem); position: absolute; background-color: transparent; margin-left: ` + marginLeft + `;">
            <div class="shadow-4 entity-search" style="height: ` + (this.quickSearches.length > 0 ? '5.6rem' : '3.75rem') + `; width: 100%; background-color:white; margin-left: 0.45rem; margin-top: 0.35rem; border-radius: 5px;">
                <div>
                    <div id="` + this.dragHandle + `" class="form-row pl-3 pb-2 pt-2" style="justify-content: center;" title="` + this.resourcesHandler.get('MovePanel') + `">
                        <h6 class="mb-1" style="font-weight: 600;">` + this.action.Text + `<i style="font-size: 1rem; font-weight: bold;" class="ml-2 ` + this.action.Icon + `"></i></h6>
                        <button id="spatial-analysis-close-` + this.controlId + `" style="color:#212529; right: -5px;" type="button" class="close position-absolute pos-top pos-right p-2 ml-1 mb-1 mt-1 mr-0"  title="` + this.resourcesHandler.get('Close') + `">
	                        <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                </div>
                <div class="panel-content panel-content pl-2 pt-0 pb-3 pr-2" style="height: 100%;">
                    <div class="form-row mb-2 ml-1" id="spatial-analysis-search-wrapper-` + this.controlId + `" style="display:none;">
                        <div class="d-flex" style="width: 380px; top: 1.5rem; left: 3.1rem; z-index: 949;">
	                        <input type="text" id="spatial-analysis-search-input-` + this.controlId + `" style="width:100%;"></input>
                        </div>
                    </div>
                    <div class="panel-content d-flex flex-row align-items-right pr-0 pb-0 mr-0 pt-0" style="padding-top: 0.85rem;">
                        <button id="` + this.point + `" class="btn btn-secondary ml-1 pt-1 pb-1 pl-2 pr-2 fal fa-location" title="` + this.resourcesHandler.get('Point') + `" type="button" style="padding-left: 0.55rem !important; padding-right: 0.55rem !important;"></button>
                        <button id="` + this.line + `" class="btn btn-secondary ml-1 pt-1 pb-1 pl-2 pr-2 fal fa-dolly-empty" title="` + this.resourcesHandler.get('Line') + `" type="button" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;"></button>
                        <button id="` + this.polygon + `" class="btn btn-secondary ml-1 pt-1 pb-1 pl-2 pr-2 fal fa-draw-polygon" title="` + this.resourcesHandler.get('Polygon') + `" type="button" style="padding-left: 0.6rem !important; padding-right: 0.6rem !important;"></button>
                        <button id="` + this.clear + `" class="btn btn-danger ml-1 pt-1 pb-1 pl-2 pr-2 fal fa-times mr-1" title="` + this.resourcesHandler.get('Cancel') + `" type="button" style="padding-left: 0.7rem !important; padding-right: 0.7rem !important; display: none;"></button>
                        <button id="` + this.search + `" class="btn btn-primary pt-1 pb-1 pl-2 pr-2 ml-auto" title="` + this.resourcesHandler.get('Search') + `" type="button">` + this.resourcesHandler.get('Search') + `</button>
                    </div>
                </div>
            </div>
            <div class="shadow-4 entity-search-results" id="entity-search-results-` + this.controlId + `" style="height: calc(100% - ` + (this.quickSearches.length > 0 ? '12.74rem' : '9.74rem') + `); width: 100%; background-color:white; margin-left: 0.45rem; margin-top: 0.15rem; border-radius: 5px;">
                <div class="panel-content p-2" style="height: 100%;">
                    <div class="form-row pl-2">
                        <h6 style="font-weight: 600;">` + this.resourcesHandler.get('Results') + `</h6>
                    </div>
                    <div class="form-row pl-1 entity-search-results-contents" style="height: calc(100% - 3.5rem); overflow-y: auto; overflow-x: hidden;">
                        <div style="width: 99%; border: none; overflow-x: hidden;" id="` + this.resultTreeId + `">
                        </div>
                    </div>
                    <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 pt-2 pl-0">
                        <button class="btn btn-danger ml-auto" id="` + this.resultTreeClear + `" title="` + this.resourcesHandler.get('ClearResults') + `" type="button">` + this.resourcesHandler.get('ClearResults') + `</button>
                        <button class="btn btn-primary ml-2" id="` + this.resultTreeReport + `" title="` + this.resourcesHandler.get('GenerateReport') + `" type="button">` + this.resourcesHandler.get('GenerateReport') + `</button>
                    </div>
                </div>
            </div>
            <div id="` + this.searchFormModalWrapper + `"></div>
        </div>`;
    }

    _getGroupedActionButtonTemplate() {
        const div = document.createElement('div');
        div.innerHTML = `<li><a class="dropdown-item" id="${this.elementId}" title="${this._getTitle()}"><i class="${this.action.Icon}" style="margin-right: 0.5rem;"></i>${this._getTitle()}</a></li>`;
        return div.firstChild;
    }

    _getActionButtonTemplate() {
        const div = document.createElement('div');
        div.innerHTML = `<li><a class="btn map-menu-item" id="${this.elementId}" title="${this._getTitle()}"><i class="${this.action.Icon}"></i></a></li>`;
        return div.firstChild;
    }

    _getTitle() {
        return this.action.Title || this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}